import LoadingSpinner from './LoadingSpinner'

const LoadingScreen = ({ text = 'Cargando...', minHeight = '850px' }) => {
  return (
    <div className="loading-fullscreen" style={{ minHeight: `min(${minHeight}, 100dvh)` }}>
      <div className="loading-card">
        <LoadingSpinner text={text} />
      </div>
    </div>
  )
}

export default LoadingScreen
